import emailjs from '@emailjs/browser';

// EmailJS Configuration
const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_be0w86m',
    PUBLIC_KEY: 'UOUyf2Bp4_igWGEmN',
    PRIVATE_KEY: 'nPYlItM2nSy9FnttXd6gb',
    TEMPLATES: {
        REPLY: 'template_travy1g',
        CONTACT_US: 'template_nwnim9i',
    },
};

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

export default EMAILJS_CONFIG;
export { emailjs };
